import { ApplicationDefinition } from "../../definitions/models/application-definition"

  /**
   * Returns a deep copy of ApplicationDefinition WITHOUT the form property.
   * Destructures form out BEFORE cloning so the large form tree is never traversed/copied.
   * Uses structuredClone (native, faster than JSON.parse/JSON.stringify).
   * Falls back to JSON parse/stringify for older environments.
   */
  export function cloneApplicationWithoutForm(definition: ApplicationDefinition): Omit<ApplicationDefinition, 'form'> {
    // destructure form out — it is never passed to the cloner
    const { form, ...rest } = definition as any;
  
    try {
      // structuredClone is available in Node 17+ / Chrome 98+ / Angular 14+ environments
      return structuredClone(rest) as Omit<ApplicationDefinition, 'form'>;
    } catch {
      // fallback for older environments
      return JSON.parse(JSON.stringify(rest)) as Omit<ApplicationDefinition, 'form'>;
    }
  }